export const SALES_BRIEF_WINDOW_TYPES = [
  ["YEAR_TO_DATE", "Year To Date"],
];

export const SALES_BRIEF_WINDOW_TYPE_VALUES = SALES_BRIEF_WINDOW_TYPES.map(
  ([value]) => value,
);
